import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import axios from 'axios';
import cn from 'classnames';
import isString from 'lodash.isstring';
import PropTypes from 'prop-types';
import { useUserStore } from '../../../stores/userStore';

const QuestionInput = ({ question, id, onChange, chosenAnswer = '' }) => {
	const { user, session } = useUserStore();
	const { question_type, care_quest_answers, required_ind } = question;
	if (question_type === 'Numeric') {
		return (
			<input
				type="number"
				id={id}
				className={cn('input', 'input-bordered')}
				onChange={onChange}
				required={required_ind}
				value={chosenAnswer}
				inputMode="decimal"
			/>
		);
	} else if (question_type === 'Date') {
		return (
			<input
				type="date"
				id={id}
				className={cn('input', 'input-bordered')}
				onChange={onChange}
				required={required_ind}
				value={chosenAnswer}
			/>
		);
	} else if (
		question_type === 'Yes/No' ||
		question_type === 'Multiple Choice Single Select'
	) {
		return (
			<select
				onChange={onChange}
				className={cn('select', 'select-bordered')}
				required={required_ind}
				value={chosenAnswer || ''}
			>
				<option disabled value="">
					Pick one
				</option>
				{care_quest_answers.map((answer) => (
					<option
						key={`${answer.care_quest_questionId}-${answer.id}`}
						value={answer.id}
					>
						{answer.answer_text}
					</option>
				))}
			</select>
		);
	} else if (question_type === 'Freetext response') {
		return (
			<textarea
				required={required_ind}
				className={cn('textarea', 'textarea-bordered')}
				onChange={onChange}
				value={chosenAnswer}
			/>
		);
	} else if (question_type === 'Multiple Choice Multiple Select') {
		return (
			<div className="grid grid-cols-3 gap-4">
				{care_quest_answers.map((answer) => (
					<div
						key={`${answer.care_quest_questionId}-${answer.id}`}
						className="form-control"
					>
						<label className="cursor-pointer label">
							<input
								name={`q-${question.id}`}
								type="checkbox"
								className="checkbox"
								value={answer.id}
								onChange={onChange}
								checked={chosenAnswer?.includes(answer.id)}
							/>
							<span className="label-text">{answer.answer_text}</span>
						</label>
					</div>
				))}
			</div>
		);
	} else if (question_type === 'document_upload') {
		const attachments = [];
		if (isString(chosenAnswer) && chosenAnswer.length > 0) {
			const attachmentLinks = chosenAnswer.split(',');
			for (let i = 0; i < attachmentLinks.length; i++) {
				const [attachmentId, type, fileName] = attachmentLinks[i].split(';');
				if (type?.includes('image')) {
					attachments.push({
						id: attachmentId,
						fileName,
						previewUrl: `${axios.defaults.baseURL}/coords/${user.id}/care-quest-response-download/${attachmentId}?access_token=${session.id}`,
					});
				} else {
					attachments.push({
						fileName,
						id: attachmentId,
					});
				}
			}
		}
		return (
			<div>
				<div>
					<input
						type="file"
						className="w-full file-input file-input-bordered"
						onChange={onChange}
						multiple
					/>
				</div>
				{attachments.map((attachment) => (
					<div key={`${attachment.id}`} className="mt-4">
						{attachment.previewUrl && (
							<div className="mb-2">
								<img
									src={attachment.previewUrl}
									className="border border-gray-400 rounded-lg image-full"
								/>
							</div>
						)}
						<a
							target="_blank"
							href={`${axios.defaults.baseURL}/coords/${user.id}/care-quest-response-download/${attachment.id}?access_token=${session.id}`}
							rel="noreferrer"
							download
							className="link link-primary"
						>
							Download {attachment.fileName}
							<ArrowTopRightOnSquareIcon className="inline-block w-4 h-4 ml-1" />
						</a>
					</div>
				))}
			</div>
		);
	}
	return null;
};

QuestionInput.propTypes = {
	question: PropTypes.object,
	id: PropTypes.string,
	onChange: PropTypes.func,
	chosenAnswer: PropTypes.any,
};

export default QuestionInput;
